export default "__VITE_ASSET__BuhjhM7C__"